import { useSelector } from 'react-redux';

const useAuth = () => {
  const { token, user } = useSelector((state) => state.authSlice);

  return {
    token,
    user,
    role: user?.role,
  };
};

export default useAuth;
